import { UBT } from '@iskytrip/ubt'

const EnvConfig = require('@src/env.config')
const UBTInstance = new (class BaseUbt extends UBT {
	event(eventId, params) {
		super.event(eventId, { ...params, Env: EnvConfig.env.toLowerCase() })
	}
})()

UBTInstance.init()

export default UBTInstance
